import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Terms = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      
      <main className="flex-grow">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <h1 className="text-3xl font-bold mb-8">Terms and Conditions</h1>
          
          <div className="prose max-w-none">
            <h2 className="text-2xl font-semibold mb-4">OVERVIEW</h2>
            <p className="mb-4">
              This website is operated by the party identified in the Contacts section of the website. Throughout the site, the terms "we", "us" and "our" refers to them. We offer this website, including all information, tools and services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here.
            </p>
            <p className="mb-4">
              By visiting our site and/ or purchasing items(s) or service(s) from us, you engage in our "Service" and agree to be bound by the following terms and conditions ("Terms of Service", "Terms"), including those additional terms and conditions and policies referenced herein. These Terms of Service apply to all users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/ or contributors of content.
            </p>
            <p className="mb-4">
              Please read these Terms of Service carefully before accessing or using our website. By accessing or using any part of the site, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, then you may not access the website or use any services. If these Terms of Service are considered an offer, acceptance is expressly limited to these Terms of Service.
            </p>
            <p className="mb-8">
              Any new features or tools which are added to the current store shall also be subject to the Terms of Service. You can review the most current version of the Terms of Service at any time on this page. We reserve the right to update, change or replace any part of these Terms of Service by posting updates and/or changes to our website. It is your responsibility to check this page periodically for changes. Your continued use of or access to the website following the posting of any changes constitutes acceptance of those changes.
            </p>

            <h2 className="text-2xl font-semibold mb-4">SECTION 1 – ONLINE STORE TERMS</h2>
            <p className="mb-4">
              By agreeing to these Terms of Service, you represent that you are at least the age of majority in your country, state or province of residence, or that you are the age of majority in your country, state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.
            </p>
            <p className="mb-4">
              You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws).
            </p>
            <p className="mb-4">
              You must not transmit any worms or viruses or any code of a destructive nature.
            </p>
            <p className="mb-8">
              A breach or violation of any of the Terms will result in an immediate termination of your Services.
            </p>

            {/* Continue with other sections */}
            <h2 className="text-2xl font-semibold mb-4">SECTION 2 – GENERAL CONDITIONS</h2>
            <p className="mb-4">
              We reserve the right to refuse service to anyone for any reason at any time.
            </p>
            <p className="mb-4">
              You understand that your content (not including credit card information), may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.
            </p>
            <p className="mb-8">
              You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without our express written permission. All of our content on our website including product images, trademarks, illustrations, designs, icons, photographs, artwork, images, and any video and/or audio materials are copyrights, trademarks, and other intellectual property owned, controlled, exclusively by us.
            </p>

            {/* Add remaining sections similarly */}
            <h2 className="text-2xl font-semibold mb-4">SECTION 20 – CONTACT INFORMATION</h2>
            <p className="mb-4">
              Questions about the Terms of Service should be sent to us at the email address in the Contacts section of our website and clearly marked in the title line: "Question about Terms of Service".
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms; 